<div class="flex h-full p-8">
	<vb-lxp-map class="grow-1" [rotation]="0" [selectedCarIds]="selectedDrivers()"></vb-lxp-map>
	<vb-lxp-panel
		class="z-1"
		#mapDrivers
		[panelKey]="'map-drivers'"
		[panelClass]="'bg-surface-container-low rounded-lg overflow-hidden'"
		[panelHeaderClass]="'p-4'"
		[panelBodyClass]="'p-4 max-h-150 overflow-y-scroll'"
		[defaultOpenState]="true"
	>
		<div header>Select drivers to follow</div>
		<div body class="flex flex-col gap-1 mt-8">
			<span
				*ngFor="let driver of drivers()"
				[ngClass]="
					selectedDrivers().includes(driver.number)
						? 'bg-secondary-container'
						: 'bg-surface-container hover:bg-surface-container-high'
				"
				class="p-2 rounded"
				(click)="onDriverClick(driver)"
				>#{{ driver.number }} - {{ driver.name }}</span
			>
		</div>
	</vb-lxp-panel>
	<button
		class="absolute bottom-8 right-8 z-0 border-border-default border-1 px-2 py-1 rounded"
		(click)="panelService.togglePanel('map-drivers')"
	>
		Driver Select
	</button>
</div>
